import { PatientEpisodeCategoryCarePath } from '@frontend/components/pages/episodeCategory/carePath/PatientEpisodeCategoryCarePath';
import type { PatientEpisodeCategoryTab } from './patientEpisodeCategoryTypes';
import { PatientEpisodeCategoryMedicalProtocol } from './PatientEpisodeCategoryMedicalProtocol';
import { PatientEpisodeCategoryMonitoring } from './PatientEpisodeCategoryMonitoring';
import { PatientEpisodeCategorySupport } from './PatientEpisodeCategorySupport';

const carePathTab: PatientEpisodeCategoryTab = {
    component: PatientEpisodeCategoryCarePath,
    key: 'carePath',
    translationKey: 'episodeCategory.episodeCategory',
};

const monitoringTab: PatientEpisodeCategoryTab = {
    component: PatientEpisodeCategoryMonitoring,
    key: 'monitoring',
    translationKey: 'common.monitoring',
};

const supportTab: PatientEpisodeCategoryTab = {
    component: PatientEpisodeCategorySupport,
    key: 'support',
    translationKey: 'common.support',
};

const medicalProtocolTab: PatientEpisodeCategoryTab = {
    component: PatientEpisodeCategoryMedicalProtocol,
    key: 'medicalProtocol',
    translationKey: 'common.medicalProtocol',
};

export const patientEpisodeCategoryTabs: PatientEpisodeCategoryTab[] = [
    carePathTab,
    monitoringTab,
    supportTab,
    medicalProtocolTab,
];
